const VARIANT_STYLES = {
    default: "",
    secondary: "aurora-badge--ghost",
    outline: "aurora-badge--ghost",
}

export function Badge({ variant = "default", className = "", as = "span", children, ...props }) {
    const Component = as
    const classes = ["aurora-badge", VARIANT_STYLES[variant] ?? "", className].filter(Boolean).join(" ")
    return (
        <Component className={classes} {...props}>
            {children}
        </Component>
    )
}

export default Badge




